
import * as S from "./styles";
import {  Grid } from "@mui/material";

import pixBetLogo from "@/assets/pixbet-logo.png";
import SampleLiveGames from "@/components/SampleLiveGames";
export default function Coupon() {


  return (
    <S.MainWrapper>
      <Grid container>
        <Grid padding={1} item sm={10} md={9}>
          <S.CouponContainer>
            <h2>Cupons de desconto</h2>
            <div className="cupon-item">
              <div className="img-box">
                <img src={pixBetLogo} alt="" />
                <div>
                  <b>100% de bônus até R$200</b>
                  <button>Usar Cupom</button>
                </div>
              </div>
              <p>
                Loren ipslon koasçdk meradiub Loren ipslon koasçdk meradiub
                Loren ipslon koasçdk meradiub Loren ipslon koasçdk meradiub
              </p>
            </div>
          </S.CouponContainer>
        </Grid>
        <Grid padding={1} item xs={12} sm={10} md={3}>
          <SampleLiveGames/>
        </Grid>
      </Grid>
    </S.MainWrapper>
  );
}
